<template>
    <div class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">培训题目</div>
                        <input type="text" class="input_box" placeholder="请输入培训题目" v-model="searchTitle" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">培训分类</div>
                        <input type="text" class="input_box" placeholder="请输入培训分类" v-model="searchType" />
                        <!-- <el-select size="small" class="select_box" v-model="searchType" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value></el-option>
							<el-option label="安全培训" value="1">安全培训</el-option>
							<el-option label="消防培训" value="2">消防培训</el-option>
						</el-select> -->
                    </div>
                    <div class="line_input">
                        <div class="input_title">培训方式</div>
                        <el-select size="small" class="select_box" v-model="searchPxType" :popper-append-to-body="false"
                            filterable placeholder="请选择" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option label="文档培训" value="1">文档培训</el-option>
                            <el-option label="视频培训" value="2">视频培训</el-option>
                            <el-option label="文档+视频培训" value="3">文档+视频培训</el-option>
                        </el-select>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                </div>
                <div class="box_line">
                    <div class="search-btn" @click="isTipsShow=true"><span>新增培训</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">培训名称</div>
                    <div class="title_item">内容描述</div>
                    <div class="title_item">培训分类</div>
                    <div class="title_item">培训方式</div>
                    <div class="title_item">是否上传</div>
                    <div class="title_item">创建时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="tableData">
                            <div class="box_line" v-for="(item, index) in tableData" :key="index">
                                <div class="list_item" :title="item.title">{{ item.title }}</div>
                                <div class="list_item" :title="item.desc">{{ item.desc }}</div>
                                <div class="list_item">{{ item.type }}</div>
                                <div class="list_item">
                                    {{ item.doc_url && item.video_url ? '视频+文档' : item.doc_url ? '文档培训' : item.video_url ? '视频培训' : '' }}
                                </div>
                                <div class="list_item" :title="item.upload_status | fnUploadObjToText">
                                    <span>{{ item.upload_status | fnUploadObjToText }}</span>
                                </div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div>
                                        <div class="search-btn" @click="fnUpload(item)"
                                            v-if="APP.fnCheckRegion('31') && !item.upload_status"><span>上传建委</span>
                                        </div>
                                        <div class="search-btn" @click="fnOpenAddOrEdit(item)"><span>编辑</span></div>
                                        <div class="search-btn red" @click="fnDelete(item)"><span>删除</span></div>
                                        <div v-if="item.doc_url" class="search-btn" @click="fnShowDoc(item.doc_url)">
                                            <span>预览文件</span>
                                        </div>
                                        <div v-if="item.video_url" class="search-btn"
                                            @click="fnShowVideo(item.video_url)"><span>预览视频</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="pageSizes" :page-size="pageSize" :current-page="currentPage"
                    layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" />
            </div>
            <div class="dialog_train" v-if="showAddOrEdit">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="新增/编辑培训" top="20vh"
                    center :visible.sync="showAddOrEdit">
                    <div class="train_box">
                        <div class="box_cont">
                            <el-form :model="form">

                                <el-form-item label="培训标题" :label-width="formLabelWidth">
                                    <el-input v-model="form.title" placeholder="请输入培训标题"></el-input>
                                </el-form-item>

                                <el-form-item label="内容描述" :label-width="formLabelWidth">
                                    <el-input style="width: 350px" type="textarea" :row="3" class="input"
                                        placeholder="请输入内容描述" v-model="form.desc" size="large"></el-input>
                                </el-form-item>

                                <el-form-item label="培训类型" :label-width="formLabelWidth">
                                    <el-select v-model="form.classify" clearable :popper-append-to-body="false"
                                        collapse-tags placeholder="请选择培训类型">
                                        <!--                <el-option label="安全教育小程序" value="1"></el-option>
                                        <el-option label="集中培训" value="2"></el-option> -->
                                        <el-option label="企业安全教育" value="3"></el-option>
                                        <el-option label="项目安全教育" value="4"></el-option>
                                        <el-option label="班组安全教育" value="5"></el-option>
                                        <el-option label="企业其他安全培训" value="6"></el-option>
                                        <el-option label="项目其他安全培训" value="7"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="培训分类" :label-width="formLabelWidth">
                                    <el-input v-model="form.type" placeholder="请输入培训分类"></el-input>
                                </el-form-item>

                                <el-form-item label="培训开始时间" :label-width="formLabelWidth">
                                    <el-date-picker size="small" v-model="form.start_at" type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期"></el-date-picker>
                                </el-form-item>

                                <el-form-item label="培训结束时间" :label-width="formLabelWidth">
                                    <el-date-picker size="small" v-model="form.end_at" type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期"></el-date-picker>
                                </el-form-item>

                                <el-form-item label="培训地点" :label-width="formLabelWidth">

                                    <el-radio-group v-model="isOnLine">
                                        <el-radio :label="true">线上</el-radio>
                                        <el-radio :label="false">线下</el-radio>
                                    </el-radio-group>

                                    <el-input v-if="!isOnLine" v-model="form.address" placeholder="请输入培训地点"></el-input>
                                </el-form-item>

                                <el-form-item label="培训人" :label-width="formLabelWidth">
                                    <el-select v-model="form.teacher" class="select_box" :popper-append-to-body="false"
                                        filterable placeholder="请选择">
                                        <el-option label="请选择" value></el-option>
                                        <el-option v-for="item in personnelList" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="参训人员" :label-width="formLabelWidth">
                                    <el-select v-model="form.participants" class="select_box"
                                        :popper-append-to-body="false" filterable placeholder="请选择" multiple
                                        collapse-tags>
                                        <el-option label="所有人员" value="all"></el-option>
                                        <el-option v-for="item in personnelList" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="关联考试" :label-width="formLabelWidth">
                                    <el-select v-model="form.tk_id" clearable :popper-append-to-body="false"
                                        collapse-tags placeholder="请选择关联的考试">
                                        <el-option label="请选择" :value="0"></el-option>
                                        <el-option v-for="(item, index) in tkList" :key="index" :label="item.title"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item v-if="isShowVisible" label="是否共享" :label-width="formLabelWidth">
                                    <el-radio-group v-model="form.is_visible">
                                        <el-radio label="1">共享</el-radio>
                                        <el-radio label="0">不共享</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item label="上传文档" :label-width="formLabelWidth">
                                    <el-upload class="avatar-uploader" action='' :http-request="res=>{
											fnUploadFile(res,'doc')
										}" :show-file-list="false">
                                        <span v-if="form.doc_url" class="file_name">{{ fileName }} 已上传</span>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"
                                            style="margin-top: 60px;"></i>
                                    </el-upload>
                                    <div class="tips">注意:只允许上传pdf,docx,doc,xlsx,pptx,ppt格式的文件</div>
                                    <div class="search-btn" style="width: 90px;" @click="fnClearImg('doc')">
                                        <span>清空文档</span>
                                    </div>
                                    <div class="search-btn" style="width: 90px;" v-if="form.doc_url"
                                        @click="fnShowDoc(form.doc_url)"><span>预览文档</span></div>
                                </el-form-item>

                                <el-form-item label="上传视频" :label-width="formLabelWidth">
                                    <el-upload class="avatar-uploader" action='' :http-request="res => {
											fnUploadFile(res, 'video');
										}" :show-file-list="false">
                                        <video v-if="form.video_url" v-bind:src="form.video_url"
                                            class="avatar video-avatar" controls="controls"></video>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"
                                            style="margin-top: 60px;"></i>
                                    </el-upload>
                                    <div class="tips">注意:只允许上传mp4,flv格式的文件</div>
                                    <div class="search-btn" style="width: 90px;" @click="fnClearImg('video')">
                                        <span>清空视频</span>
                                    </div>
                                </el-form-item>


                                <el-form-item label="培训照片" :label-width="formLabelWidth">
                                    <el-upload class="avatar-uploader" action='' :http-request="res => {
                                			fnUploadFile(res, 'photo');
                                		}" :show-file-list="false">
                                        <img v-if="form.photo" :src="form.photo" class="avatar"
                                            style="width: 238px;height: 178px;border-radius: 5px;" />
                                        <i v-else class="el-icon-plus avatar-uploader-icon"
                                            style="margin-top: 60px;"></i>
                                    </el-upload>
                                    <div class="search-btn" style="width: 90px;" v-if="form.photo"
                                        @click="fnShowDoc(form.photo)"><span>预览图片</span></div>
                                </el-form-item>

                            </el-form>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showAddOrEdit = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSaveAddOrEdit"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <div class="dialog_trainList" v-if="isShowTrainList">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="培训列表库" top="20vh"
                    center :visible.sync="isShowTrainList">
                    <div class="train_list">
                        <div class="list_title">
                            <div class="title_item">选择</div>
                            <div class="title_item">培训名称</div>
                            <div class="title_item">培训分类</div>
                            <div class="title_item">培训方式</div>
                            <div class="title_item">操作</div>
                        </div>
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="tableDataTrain">
                                    <div class="box_line" v-for="(item, index) in tableDataTrain" :key="index"
                                        @click="fnHandleCheckedChange(item,index)">
                                        <div class="list_item">
                                            <div class="select" :class="item.selected ? 'active' : ''"></div>
                                        </div>
                                        <div class="list_item">{{ item.title }}</div>
                                        <div class="list_item">{{ item.type }}</div>
                                        <div class="list_item">
                                            {{ item.doc_url && item.video_url ? '视频+文档' : item.doc_url ? '文档培训' : item.video_url ? '视频培训' : '' }}
                                        </div>
                                        <div class="list_item">
                                            <div>
                                                <div v-if="item.doc_url" class="search-btn" style="width: 70px;"
                                                    @click="fnShowDoc(item.doc_url)"><span>预览文件</span></div>
                                                <div v-if="item.video_url" class="search-btn" style="width: 70px;"
                                                    @click="fnShowVideo(item.video_url)"><span>预览视频</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="train_page">
                        <el-pagination background @size-change="handleSizeChangeTrain"
                            @current-change="handleCurrentChangeTrain" :page-sizes="pageSizesTrain"
                            :page-size="pageSizeTrain" :current-page="currentPageTrain"
                            layout="total, sizes, prev, pager, next, jumper" :total="pageTotalTrain" />
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="isShowTrainList = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSaveSelectTrain"><span>确定</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- 人员下发失败信息弹窗 -->
            <div class="dialog_isBlack" v-if="isTipsShow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="提示信息"
                    :visible.sync="isTipsShow" center>
                    <div>是否从公共培训库内选取素材？</div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" style="width: 70px;" @click="fnOpenAddOrEdit"><span>否</span>
                            </div>
                            <div class="search-btn" style="width: 70px;"
                                @click="isShowTrainList = true;isTipsShow=false"><span>是</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <div class="dialog_showVideo" v-if="isShowVideo">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="提示信息"
                    :visible.sync="isShowVideo" center>
                    <div class="video_box">
                        <video v-if="doc_url" :src="doc_url" controls="controls"></video>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="isShowVideo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import APP from '@/utils/base';
    import request from '@/utils/request';
    import {
        fnUploadDocOrVideo
    } from '@/utils/upload';
    import axios from 'axios';
    import {
        getUserInfo
    } from '@/utils/auth'
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    export default {
        data() {
            return {
                APP: APP,
                // 分页
                pageSize: APP.PAGE.LIMIT,
                pageSizes: APP.PAGE.SIZE_OPTION,
                currentPage: APP.PAGE.SKIP_PAGE,
                pageTotal: 0,
                pageSizeTrain: APP.PAGE.LIMIT,
                pageSizesTrain: APP.PAGE.SIZE_OPTION,
                currentPageTrain: APP.PAGE.SKIP_PAGE,
                pageTotalTrain: 0,
                // 搜索
                searchTitle: '', // 培训题目搜索
                searchType: '', // 培训分类搜索
                searchPxType: '', // 培训方式搜索
                // 培训列表
                tableData: [], // 培训列表数据
                tableDataTrain: [], // 培训列表库数据
                // 弹窗
                isTipsShow: false, // 提示框
                isShowTrainList: false, // 培训列表库弹窗
                showAddOrEdit: false, // 新增/编辑培训
                formLabelWidth: '120px', // 弹窗label宽度
                form: {
                    id: '',
                    title: '', // 培训标题
                    desc: '', // 培训描述信息
                    type: '', // 培训分类
                    doc_url: '', // 培训文档
                    video_url: '', // 培训视频
                    tk_id: 0, // 关联题库id
                    is_visible: '1',

                    classify: '', // 培训类型
                    start_at: '', // 开始时间
                    end_at: '', // 结束时间
                    teacher: '', // 培训人
                    address: '', // 培训地点
                    participants: [], // 参训人员
                    photo: '', // 培训照片
                },
                isShowVisible: true,
                fileName: '', // 文件名
                tkList: [], // 所有题库列表
                selectTk: null,
                isShowVideo: false,
                doc_url: null,
                personnelList: [], // 所有人员信息
                isOnLine: true, // 是否线上培训
            };
        },
        created() {
            this.fnInit();
            this.fnGetAllTkList();
            this.fnGetAllPersonnel();
        },
        methods: {
            // 初始化
            fnInit() {
                this.fnGetTrainList({
                        page: this.currentPage,
                        size: this.pageSize
                    },
                    res => {
                        let _arr = res.data.query;
                        if (_arr.length > 0) {
                            this.tableData = _arr;
                        } else {
                            this.tableData = [];
                            this.$message.warning('暂无数据');
                        }
                        this.pageTotal = res.data.count;
                    }
                );
                this.fnSearchTrain(0)
            },

            // 获取项目下所有人员
            fnGetAllPersonnel() {
                request({
                        url: 'personnel/getUploadAllPersonnel',
                        method: 'GET',
                        params: {
                            extend: 'cq2'
                        }
                    })
                    .then(res => {
                        this.personnelList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },

            // 培训库 弹窗列表
            fnSearchTrain(page) {
                this.fnGetTrainList({
                    page: page ? page : this.currentPageTrain,
                    size: this.pageSizeTrain,
                    is_visible: 1
                }, res => {
                    let _arr = res.data.query
                    if (_arr.length > 0) {
                        for (let i in _arr) {
                            _arr[i].selected = false
                        }
                        this.tableDataTrain = _arr
                    } else {
                        this.tableDataTrain = []
                    }
                    this.pageTotalTrain = res.data.count
                })
            },
            // 获取所有题库列表
            fnGetAllTkList() {
                request({
                        url: 'exam/tk/allTks',
                        method: 'GET'
                    })
                    .then(res => {
                        this.tkList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 分页选择
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnSearch();
            },
            // 分页跳转
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnSearch();
            },
            // 分页选择 弹窗列表
            handleSizeChangeTrain(val) {
                this.pageSizeTrain = val;
                this.fnSearchTrain()
            },
            // 分页跳转
            handleCurrentChangeTrain(val) {
                this.currentPageTrain = val;
                this.fnSearchTrain()
            },
            // 弹窗单项选择
            fnHandleCheckedChange(item, index) {
                for (let i in this.tableDataTrain) {
                    if (i == index) {
                        this.tableDataTrain[i].selected = true
                    } else {
                        this.tableDataTrain[i].selected = false
                    }
                }
                let _item = JSON.parse(JSON.stringify(item))
                delete _item.selected
                this.selectTk = _item
            },
            // 清空视频或文档
            fnClearImg(_type) {
                if (_type == 'video') {
                    this.form.video_url = '';
                } else {
                    this.form.doc_url = '';
                }
            },
            // 获取培训列表
            fnGetTrainList(_obj, _cb) {
                request({
                        url: 'exam/exercise/lists',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        _cb && _cb(res);
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 搜索
            fnSearch(_isInit) {
                this.fnGetTrainList({
                        page: _isInit ? 1 : this.currentPage,
                        size: this.pageSize,
                        title: this.searchTitle,
                        type: this.searchType,
                        px_type: this.searchPxType
                    },
                    res => {
                        let _arr = res.data.query;
                        if (_arr.length > 0) {
                            this.tableData = _arr;
                        } else {
                            this.tableData = [];
                            this.$message.warning('暂无搜索数据');
                        }
                        this.pageTotal = res.data.count;
                    }
                );
            },
            // 修改人员状态
            fnChangeStatus(_data) {
                let _personnel_id = _data.id;
                let _status = _data.status ? 0 : 1;
                request({
                        url: 'personnel/changeStatus',
                        method: 'POST',
                        data: {
                            status: _status,
                            personnel_id: _personnel_id
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.fnSearch();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 新增/编辑专项培训 打开弹窗
            fnOpenAddOrEdit(item) {
                this.isTipsShow = false
                if (item && item.id) {
                    this.form.id = item.id;
                    this.form.title = item.title;
                    this.form.desc = item.desc;
                    this.form.type = item.type;
                    this.form.doc_url = item.doc_url;
                    this.form.video_url = item.video_url;
                    this.fileName = item.title;
                    this.form.tk_id = parseInt(item.tk_id);

                    this.form.classify = item.classify;
                    this.form.start_at = item.start_at;
                    this.form.end_at = item.end_at;
                    this.form.teacher = parseInt(item.teacher);
                    this.isOnLine = item.address == '线上'
                    this.form.address = this.isOnLine ? '' : item.address;
                    this.form.participants = item.participants ? JSON.parse(item.participants) : [];
                    this.form.photo = item.photo;
                } else {
                    this.form.id = null;
                    this.form.title = '';
                    this.form.desc = '';
                    this.form.type = '';
                    this.form.doc_url = '';
                    this.form.video_url = '';
                    this.form.tk_id = 0;

                    this.form.classify = '';
                    this.form.start_at = '';
                    this.form.end_at = '';
                    this.form.teacher = '';
                    this.isOnLine = true
                    this.form.address = '';
                    this.form.participants = [];
                    this.form.photo = '';
                }
                this.showAddOrEdit = true;
            },
            // 从试题库中选择并打开弹窗
            fnSaveSelectTrain() {
                let item = this.selectTk
                this.isShowTrainList = false
                this.form.id = null;
                this.form.title = item.title;
                this.form.desc = item.desc;
                this.form.type = item.type;
                this.form.doc_url = item.doc_url;
                this.form.video_url = item.video_url;
                this.form.is_visible = '0'
                this.isShowVisible = false
                this.fileName = item.title;
                this.form.tk_id = parseInt(item.tk_id);
                this.showAddOrEdit = true;
            },
            // 新增/编辑专项培训 保存
            fnSaveAddOrEdit() {

                let form = JSON.parse(JSON.stringify(this.form))

                if (!form.title) {
                    this.$message.warning('请输入培训标题');
                    return;
                }
                if (!form.desc) {
                    this.$message.warning('请输入内容描述');
                    return;
                }
                if (!form.classify) {
                    this.$message.warning('请选择培训类型');
                    return;
                }
                if (!form.type) {
                    this.$message.warning('请输入培训分类');
                    return;
                }
                if (form.type.length > 4) {
                    this.$message.warning('输入的培训分类不超过4个字');
                    return;
                }
                if (!form.start_at) {
                    this.$message.warning('请选择培训开始时间');
                    return;
                }
                if (!form.end_at) {
                    this.$message.warning('请选择培训结束时间');
                    return;
                }

                if (!this.isOnLine && !form.address) {
                    this.$message.warning('请输入线下培训地点');
                    return;
                }

                if (!this.isOnLine && !form.teacher) {
                    this.$message.warning('请选择线下培训人');
                    return;
                }

                if (!form.participants) {
                    this.$message.warning('请选择参训人员');
                    return;
                }

                if (this.isOnLine && form.doc_url == '' && form.video_url == '') {
                    this.$message.warning('请选择上传培训视频或者培训文档');
                    return;
                }

                if (this.isOnLine) {
                    form.address = '线上'
                }

                form.participants = JSON.stringify(this.form.participants)

                let _url = this.form.id ? 'exam/exercise/edit' : 'exam/exercise/add';
                request({
                        url: _url,
                        method: 'POST',
                        data: form
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.showAddOrEdit = false;
                        this.fnInit();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 删除专项培训
            fnDelete(_data) {
                request({
                        url: 'exam/exercise/del',
                        method: 'POST',
                        data: {
                            id: _data.id
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.fnInit();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 预览文件
            fnShowDoc(_url) {
                window.open(_url)
            },
            // 预览视频
            fnShowVideo(_url) {
                this.doc_url = _url
                this.isShowVideo = true
            },
            // 上传文件
            fnUploadFile(param, type) {
                let _file = param.file
                let _fileName = _file.name
                let _fileSize = _file.size
                let _fileSuffix = APP.fnGetSuffix(_fileName)
                let _newFileName = getUserInfo().id + '/' + APP.fnGetTime('upload') + '/' + APP.fnGetRandomName(10) +
                    '.' + _fileSuffix
                request({
                    url: 'file/sign',
                    method: 'get'
                }).then(res => {
                    let _limit = res.data.limit
                    if (type == 'doc') {
                        let _limit_doc_max_size = _limit.doc.max_size
                        if (_fileSize > _limit_doc_max_size) return this.$message.warning('上传的文件不能超过' +
                            parseInt(_limit_doc_max_size / 1048576) + 'M!')
                        let _limit_doc_type = _limit.doc.types
                        let _isDoc = false
                        for (let i in _limit_doc_type) {
                            if (_limit_doc_type[i] == _fileSuffix) {
                                _isDoc = true
                            }
                        }
                        if (!_isDoc) return this.$message.warning('只能上传格式为pdf,doc,docx,xlsx,pptx,ppt的文件')
                    } else if (type == 'video') {
                        let _limit_video_max_size = _limit.video.max_size
                        if (_fileSize > _limit_video_max_size) return this.$message.warning('上传的文件不能超过' +
                            parseInt(_limit_doc_max_size / 1048576) + 'M!')
                        let _limit_video_type = _limit.video.types
                        let _isVideo = false
                        for (let i in _limit_video_type) {
                            if (_limit_video_type[i] == _fileSuffix) {
                                _isVideo = true
                            }
                        }
                        if (!_isVideo) return this.$message.warning('只能上传格式为mp4,flv的文件')
                    }
                    let _data = res.data.upload_param
                    let formData = new FormData();
                    formData.append('OSSAccessKeyId', _data.accessid)
                    formData.append('key', _data.dir + _newFileName)
                    formData.append('policy', _data.policy)
                    formData.append('signature', _data.signature)
                    formData.append('success_action_status', 200)
                    formData.append('file', _file)
                    axios.post(_data.host, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(res => {
                            if (res.status == 200) {

                                let url = _data.host + '/' + _data.dir + _newFileName
                                if (type == 'doc') {
                                    this.fileName = _fileName
                                    this.form.doc_url = url
                                }
                                if (type == 'photo') {
                                    this.form.photo = url
                                } else {
                                    this.form.video_url = url
                                }
                                this.$message.success('上传成功!')
                            }
                        })
                        .catch(err => {
                            this.$message.error('上传失败!')
                        })
                })
            },

            fnUpload(_data) {
                fnRequestPlatform({
                        url: '/Cq2/uploadWorkerEducationTrain',
                        method: 'POST',
                        data: {
                            carry: _data
                        }
                    },
                    res => {
                        if (res.code === 1) {
                            this.$message.success(res.data);
                        } else {
                            this.$message.error(res.data);
                        }

                        this.fnInit();
                    }
                );
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '@/styles/mixin.scss';

    .person_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .person {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        height: 84px;
        width: 1880px;
        margin-top: 24px;
        margin-left: 20px;
        @include flex-box(space-between, center, column);

        .box_line {
            width: 1880px;
            height: 32px;
            @include flex-box(flex-start, center);

            .line_input {
                min-width: 280px;
                height: 30px;
                margin-right: 10px;
                border-top-right-radius: 1px;
                border-bottom-right-radius: 1px;
                background-color: rgba(49, 88, 128, 0.4);
                @include flex-box(flex-start, center);

                .input_title {
                    width: 69px;
                    height: 30px;
                    font-size: 14px;
                    color: #9bf9fc;
                    border-radius: 2px;
                    background-color: rgba(155, 249, 252, 0.1);
                    @include flex-box(center, center);
                }

                .input_box {
                    width: 211px;
                    height: 30px;
                    line-height: 30px;
                    padding-left: 15px;
                    color: rgba(77, 180, 244, 0.7);
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    background: transparent;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 211px;
                    height: 30px;
                    border-radius: 2px;
                }
            }
        }
    }

    .cont_list {
        margin-top: 29px;
        margin-left: 28px;
        width: 1864px;
        // height: 561px;
        height: 625px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1864px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 286px;
                    margin: 0 4px 0 40px;
                }

                &:nth-child(2) {
                    width: 330px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 180px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 180px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 229px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 229px;
                    margin-right: 4px;
                }

                &:nth-child(7) {
                    width: 330px;
                    margin-right: 40px;
                }

                .select {
                    width: 20px;
                    height: 20px;
                    border: 1px solid #65a6dd;
                    border-radius: 2px;
                    cursor: pointer;
                    @include prefixCss3(transition, border-color 0.2s);

                    &:hover {
                        border-color: #409eff;
                    }

                    &.active {
                        background-color: #409eff;
                        border-color: #409eff;

                        &::after {
                            content: '';
                            display: block;
                            width: 100%;
                            height: 100%;
                            @include set-bg-img('../../../assets/images/icon-yes.png');
                        }
                    }
                }
            }
        }

        .list_boxes {
            width: 1864px;
            height: 577px;
            // height: 513px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1784px;
                    height: 70px;
                    margin: 7px 0 0 40px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    &:hover {
                        background-color: rgba(49, 88, 128, 0.4);
                    }

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 286px;
                            margin-right: 4px;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        &:nth-child(2) {
                            width: 330px;
                            margin-right: 4px;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        &:nth-child(3) {
                            width: 180px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 180px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 229px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 229px;
                            margin-right: 4px;
                        }

                        &:nth-child(7) {
                            width: 330px;
                        }

                        div {
                            @include flex-box(center, center);
                        }

                        .select {
                            width: 20px;
                            height: 20px;
                            border: 1px solid #65a6dd;
                            border-radius: 2px;
                            cursor: pointer;
                            @include prefixCss3(transition, border-color 0.2s);

                            &:hover {
                                border-color: #409eff;
                            }

                            &.active {
                                background-color: #409eff;
                                border-color: #409eff;

                                &::after {
                                    content: '';
                                    display: block;
                                    width: 100%;
                                    height: 100%;
                                    @include set-bg-img('../../../assets/images/icon-yes.png');
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .box_line {
        >>>.el-input__inner {
            width: 211px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-select__caret {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-select-dropdown {
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(77, 180, 244, 1);
        }

        >>>.popper__arrow {
            border-bottom-color: rgba(77, 180, 244, 1) !important;
        }

        >>>.el-select-dropdown__item {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-select-dropdown__item:hover {
            color: #409eff;
        }

        >>>.el-select-dropdown__item.hover {
            color: #409eff;
        }

        >>>.el-input__icon {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-range-input {
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-range-separator {
            color: rgba(77, 180, 244, 0.7);
        }
    }

    .dialog_train {
        >>>.el-dialog {
            width: 910px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid #3a74dd;
        }

        .train_box {
            width: 860px;
            height: 450px;
            color: #ffffff;
            font-size: 16px;
            position: relative;
            overflow: hidden;

            .box_cont {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;
            }
        }

        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-radio__label {
            color: #4DB4F4;
        }

        >>>.el-input__inner {
            width: 450px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background-color: rgba(77, 180, 244, 0.2);

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        >>>.el-select {
            .el-input {
                .el-select__caret {
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }

        >>>.el-select-dropdown {
            // background-color: rgba(9, 17, 32, 0.5);
            // border: 1px solid rgba(77, 180, 244, 1);
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(77, 180, 244, 1);
        }

        >>>.el-select-dropdown__item {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-select-dropdown__item:hover {
            color: #409eff;
        }

        >>>.el-select-dropdown__item.hover {
            color: #409eff;
        }

        >>>.el-dropdown-menu__item--divided {
            border-top: rgba(29, 68, 149, 0.5);
            color: #9cf8fb;
        }

        >>>.el-dropdown-menu__item--divided::before {
            background-color: rgba(29, 68, 149, 0.5);
            height: 0;
        }

        >>>.popper__arrow {
            border-bottom-color: rgba(77, 180, 244, 1) !important;
        }

        >>>.avatar-uploader {

            // line-height: 240px;
            video {
                width: 238px;
                height: 176px;
                border-radius: 5px;
            }
        }

        >>>.el-upload {
            width: 240px;
            height: 180px;
            line-height: 100px;
            border-radius: 5px;
            font-size: 36px;
            border: 1px dashed rgba(77, 180, 244, 1);
        }

        .tips {
            font-size: 12px;
            color: #FF4949;
        }

        .file_name {
            width: 220rpx;
            margin-top: 60px;
            height: 60px;
            line-height: 20px;
            font-size: 12px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
        }
    }

    .dialog_trainList {
        >>>.el-dialog {
            width: 1000px;
            height: 690px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid #3a74dd;
        }

        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__body {
            padding: 0px 20px;
        }

        .train_list {
            width: 960px;
            height: 510px;
            border-radius: 10px;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 960px;
                height: 48px;
                color: #4db4f4;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 46px;
                        margin-right: 4px;
                        margin-left: 40px;
                    }

                    &:nth-child(2) {
                        width: 346px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 156px;
                        margin-right: 4px;
                    }

                    &:nth-child(4) {
                        width: 156px;
                        margin-right: 4px;
                    }

                    &:nth-child(5) {
                        width: 160px;
                        margin-right: 40px;
                    }

                    .select {
                        width: 20px;
                        height: 20px;
                        border: 1px solid #65a6dd;
                        border-radius: 2px;
                        cursor: pointer;
                        @include prefixCss3(transition, border-color 0.2s);

                        &:hover {
                            border-color: #409eff;
                        }

                        &.active {
                            background-color: #409eff;
                            border-color: #409eff;

                            &::after {
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                @include set-bg-img('../../../assets/images/icon-yes.png');
                            }
                        }
                    }
                }
            }

            .list_boxes {
                width: 960px;
                height: 462px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 880px;
                        height: 70px;
                        margin: 7px 0 0 40px;
                        font-size: 16px;
                        color: #ffffff;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 46px;
                                margin-right: 4px;
                            }

                            &:nth-child(2) {
                                width: 346px;
                                margin-right: 4px;
                            }

                            &:nth-child(3) {
                                width: 156px;
                                margin-right: 4px;
                            }

                            &:nth-child(4) {
                                width: 156px;
                                margin-right: 4px;
                            }

                            &:nth-child(5) {
                                width: 160px;
                            }

                            div {
                                @include flex-box(center, center);
                            }

                            span {
                                width: 100%;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            .select {
                                width: 20px;
                                height: 20px;
                                border: 1px solid #65a6dd;
                                border-radius: 2px;
                                cursor: pointer;
                                @include prefixCss3(transition, border-color 0.2s);

                                &:hover {
                                    border-color: #409eff;
                                }

                                &.active {
                                    background-color: #409eff;
                                    border-color: #409eff;

                                    &::after {
                                        content: '';
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                        @include set-bg-img('../../../assets/images/icon-yes.png');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .train_page {
            width: 960px;
            height: 30px;
            margin-top: 10px;

            >>>.el-pagination__total {
                color: #439fe3;
                font-size: 14px !important;
            }

            >>>.el-input__inner {
                background-color: rgba(49, 88, 128, 0.5) !important;
                border: none !important;
                color: #439fe3 !important;
            }

            >>>.el-pagination__jump {
                color: #439fe3;
                font-size: 14px !important;
            }

            >>>.el-select__caret {
                color: #439fe3;
            }

            >>>.el-pagination.is-background .btn-prev {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .btn-prev:disabled {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .btn-next {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .btn-next:disabled {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .el-pager li {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #50aaff !important;
                color: #091027;
            }
        }
    }

    .dialog_isBlack {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 500px;
            height: 200px;
            margin-top: 40vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4DB4F4;
        }

        >>>.el-dialog__title {
            color: #4DB4F4;
        }

        >>>.el-dialog__close {
            color: #4DB4F4;
        }

        div {
            width: 100%;
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
        }
    }

    .dialog_showVideo {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 700px;
            height: 535px;
            margin-top: 25vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4DB4F4;
        }

        >>>.el-dialog__body {
            padding: 20px;
        }

        >>>.el-dialog__title {
            color: #4DB4F4;
        }

        >>>.el-dialog__close {
            color: #4DB4F4;
        }

        .video_box {
            width: 660px;
            height: 380px;

            video {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/SpecialTrain/specialTrainDefault/index.vue